import WhiteMenu from '../../../../../media/felsv/white_horizontal_menu.svg'
import DarkFileDelete from '../../../../../media/felsv/dark_delete_file_icon.svg'
import { actionFacturacionEmision } from '../../../../../actions/action-creators'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

const FooterFinalizacionV1 = () => {
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionFacturacionEmision, dispatch)

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell' style={{background: 'transparent'}}>
      <div className='card' style={{background: 'transparent'}}>
        <div className='w-layout-vflex card-content'>
          <div className='w-layout-hflex button-actions'>
            {/* <button className='m button transparent botton-footer' onClick={() => actionsFE.facturacionOpenCloseModalAnular(true)}>
              <img src={DarkFileDelete} loading='lazy' alt='Anular factura'/>
              <div>Anular documento</div>
            </button> */}
            <div style={{width: '90%'}}></div>
            <button className='m button w-inline-block w-auto' onClick={actionsFE.facturacionOpenMasOpciones} style={{minWidth: '170px'}}>
              <img src={WhiteMenu} loading='lazy' alt='Más opciones'/>
              <div>Más opciones</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterFinalizacionV1
